/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Filters_Active_CountInputs */



/**
* | output |
* | --- |
* | "Filters ({count} active)" |
*
* @param {Filters_Active_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const filters_active_count = /** @type {((inputs: Filters_Active_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filters_Active_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Filtres (actifs : ${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Filtros (activos: ${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Filtros (ativos: ${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Filtri (attivi: ${i?.count})`)
	return /** @type {LocalizedString} */ (`Filters (${i?.count} active)`)
});